<div class="container" #dialog>
  <div
    class="option-item"
    data-cy="mimics-more-options-option"
    *ngFor="let option of data.optionItemList"
    (click)="selectOption(option, $event)"
    [class.new-option]="option.new"
    [class.selected]="
      selectedOptionItem?.svg === option.svg && selectedOptionItem?.label === option.label
    "
    [class.disabled]="option?.disabled">
    <div class="option-title" *ngIf="!option.new">
      <mat-icon *ngIf="option.svg" class="option-icon" [svgIcon]="option.svg"></mat-icon>
      <span class="option-name" data-cy="mimics-more-options-option-name">{{
        option.label | translate
      }}</span>
    </div>
    <span data-cy="mimics-more-options-option-name-create-buttons" *ngIf="option.new">{{
      '+ ' + (option.label | translate)
    }}</span>
    <mat-icon
      class="option-arrow"
      [class.show]="option.arrowIcon"
      svgIcon="dropdown-arrow"></mat-icon>
  </div>
</div>
